<nav ngbNav #nav="ngbNav" class="nav-tabs">

  <ng-container ngbNavItem *qmAuth="'LinkingMisonetComponent'">
    <a ngbNavLink>{{'MISONET-Linkings' | translate}}</a>
    <ng-template ngbNavContent>
      <qm-linking-misonet></qm-linking-misonet>
    </ng-template>
  </ng-container>

  <ng-container ngbNavItem *qmAuth="'LinkingVivoComponent'">
    <a ngbNavLink>{{'VIVO-Linkings' | translate}}</a>
    <ng-template ngbNavContent>
      <qm-linking-vivo></qm-linking-vivo>
    </ng-template>
  </ng-container>

  <ng-container ngbNavItem *qmAuth="'LinkingValmetComponent'">
    <a ngbNavLink>{{'VALMET-Linkings' | translate}}</a>
    <ng-template ngbNavContent>
      <qm-linking-valmet></qm-linking-valmet>
    </ng-template>
  </ng-container>
</nav>

<div [ngbNavOutlet]="nav" class="mt-2"></div>
